<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>ჩაანაცვლე ძველი ავტომობილი ახლით - მარტივად</h1>
    <h2><span class="highlight-text"> თიბისი ლიზინგის ახალი პროდუქტი</span></h2>
    <h6>მაისი 2024</h6>
    <br />

    <p>
      გაზაფხული საკმაოდ კარგი პერიოდია იმისთვის, რომ ზამთარში გაჩენილი და გვერდზე გადადებული იდეები განახორციელო.
      მაგალითად: გამონახო დრო და დაკავდე საყვარელი ჰობით, გახსნა ანაბარი შენი ხანგრძლივი მიზნების განსახორციელებლად, ან
      თუნდაც - იყიდო ახალი ავტომობილი. კარგად ჟღერს, მაგრამ ოპერაციები, რომელიც ამ ყველაფრის განხორციელებისთვის უნდა
      ჩაატარო - მთავარი წინაღობაა. ძველის გაყიდვა, გაუმჯობესებული ვარიანტისთვის რესურსის მოძიება ან დაფინანსების გზების
      მოფიქრება, გაყიდვა-გადაფორმება და გადმოფორმება? ბევრი საბუთი და კიდევ უფრო მეტი ლოკაცია, რომელზეც უნდა მიხვიდე.
    </p>

    <img src="/assets/blog/swap-car/img1.jpg" alt="" />

    <p class="quote-sign dark-blue">“</p>

    <p class="dark-blue">
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        ჩვენი პროდუქტების განვითარების გუნდი ავტომოტივთან ერთად დაფიქრდა, როგორ შეიძლება გამარტივდეს პროცესი, რომელსაც
        ძალიან სასიამოვნო დასასრული - ახალი ავტომობილის ყიდვა მოსდევს.
      </b>
    </p>

    <p class="right-align">ეკატერინე ანჯაფარიძე, <br />ავტო მიმართულების ხელმძღვანელი.<br /></p>

    <p>
      რეალურად, ახალი ველოსიპედი არ გამოგვიგონია, დიდი ხანია რაც ევროპასა და ამერიკაში აპრობირებული მეთოდით ნაცვლდება
      ძველი ავტომობილი ახლით.
    </p>

    <p class="quote-sign dark-blue">“</p>

    <p class="dark-blue">
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        ერთი ფანჯრის პრინციპი - ერთი ვიზიტის, ან ერთი სივრცისას შეგვიძლია მოვარგოთ. მომხმარებელი მოდის აღმაშენებლის
        ხეივნის ფილიალში საკუთარი ავტომობილით. ვასურათებთ, ვაფასებთ და ვიბარებთ. ოპერაციას მომხმარებლისთვის მაქსიმალურად
        მომგებიანი წინადადებით მინიმალურ დროში ვხურავთ.
      </b>
    </p>

    <p>
      ჰო, შენი ავტომობილის ხანდაზმულობის ვადა 10 წელს არ უნდა აჭარბებდეს, ანუ მაქსიმუმ 2013 წელს უნდა იყოს გამოშვებული.
      რა თქმა უნდა, საჭიროა ტექ. დათვალიერების ვალიდური, აქტიური საბუთი. აღნიშნული ინფორმაციისაა და შემფასებლების
      დასკვნის მიხედვით გეტყვით, შენი ახალი ავტომობილის ღირებულებას რამდენი გამოაკლდება, ანუ რა ჩაითვლება
      თანამონაწილეობის თანხად.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <img class="full-width-image" src="/assets/blog/swap-car/img2.jpg" alt="" />
  </div>

  <div class="container blog-item custom">
    <p class="quote-sign dark-blue">“</p>

    <p class="dark-blue">
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        მეორე ეტაპია ახალი, ანუ მომხმარებლის მიერ შერჩეული ავტომობილის შეფასება. მის ღირებულებას ძველის შეფასება
        გამოაკლდება და მიღებული სხვაობა ლიზინგის ოდენობად ითარგმნება. ანუ, ლიზინგის თანხა, მიღებული X ლარი გრაფიკით
        გადანაწილდება.
      </b>
    </p>

    <p>
      არ დაგავიწყდეს, რომ მომსახურების სააგენტოს ყველა საჭირო სერვისსაც ადგილზე მიიღებ. ანუ, ასე მარტივად, მოხვალ
      ფილიალში ძველით, სახლში კი ახალი, ანუ ჩანაცვლებული მოდელით დაბრუნდები.
    </p>

    <p>
      თუ შეკითხვები გაქვს, აუცილებლად მოგვწერე, ან თვალი ადევნე ჩვენს არხებს, სადაც მომხმარებლების რეალური მაგალითებით
      მოგიყვებით, რატომ უნდა ისარგებლო ახალი პროდუქტით.
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>Replace the old car with a new one – easily</h1>
    <h2><span class="highlight-text">TBC Leasing's new product</span></h2>
    <h6>May 2024</h6>
    <br />

    <p>
      Spring is quite a good time to implement ideas that were set aside during the winter. For example: finding time to
      engage in a beloved hobby, opening a savings account to achieve your long-term goals, or even – buying a new car.
      It sounds good, but the operations required to make all this happen are the main obstacle. Selling the old one,
      finding resources for an upgraded option or thinking of financing methods, selling, transferring ownership, and
      re-registering? A lot of paperwork and even more locations you need to visit.
    </p>

    <img src="/assets/blog/swap-car/img1.jpg" alt="" />

    <p class="quote-sign dark-blue">“</p>

    <p class="dark-blue">
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        Our product development team, together with the automotive department, thought about how the process could be
        simplified, which ends with a very pleasant conclusion – the purchase of a new car.
      </b>
    </p>

    <p class="right-align">Ekaterine Anjafaridze, <br />Head of the Automotive Department.<br /></p>

    <p>
      In reality, we haven’t invented a new bicycle; the method of replacing an old car with a new one has been tested
      in Europe and America for a long time.
    </p>

    <p class="quote-sign dark-blue">“</p>

    <p class="dark-blue">
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        One-window principle – we can adapt it to one visit or one space. The customer comes to the Agmashenebeli Avenue
        branch with their car. We take a picture, evaluate, and accept it. We close the operation with the most
        beneficial offer for the customer in the shortest time possible.
      </b>
    </p>

    <p>
      Yes, your car’s age should not exceed 10 years, meaning it should have been manufactured no later than 2013. Of
      course, a valid, active technical inspection certificate is required. Based on this information and the
      appraisers’ conclusion, we will inform you how much will be deducted from the value of your new car, i.e., what
      will be counted as your contribution.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <img class="full-width-image" src="/assets/blog/swap-car/img2.jpg" alt="" />
  </div>

  <div class="container blog-item custom">
    <p class="quote-sign dark-blue">“</p>

    <p class="dark-blue">
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        The second stage is the evaluation of the new car, i.e., the car selected by the customer. Its value will have
        the old car’s evaluation deducted, and the resulting difference will be translated into the leasing amount. In
        other words, the leasing amount, the obtained X GEL, will be distributed according to the schedule
      </b>
    </p>

    <p>
      Don’t forget that you will receive all the necessary services of the agency on-site. In other words, you will come
      to the branch with your old car, and return home with a new, i.e., replaced model.
    </p>

    <p>
      If you have any questions, feel free to write to us or follow our channels, where we will share real examples from
      customers, showing why you should take advantage of the new product.
    </p>
  </div>
</ng-container>
